module.exports = __webpack_public_path__ + "static/media/repeatable-footer-off-preview.89949ae2.png";